import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
export var useSimpleTable = function (columns, data) {
    var table = useReactTable({
        data: data,
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
        autoResetPageIndex: false,
        initialState: {
            pagination: {
                pageSize: data.length,
            },
        },
    });
    return {
        getHeaderGroups: table.getHeaderGroups,
        getRowModel: table.getRowModel,
    };
};
